module.exports = __webpack_public_path__ + "static/media/book.e3a61287.svg";